// extracted by mini-css-extract-plugin
export default {"layoutBackground":"layout_layoutBackground__r8DZ0","layoutWrapper":"layout_layoutWrapper__14TTe","layoutMain":"layout_layoutMain__jxLEa"};